import React, { useEffect, useState } from "react";
import {
  getDeliveryInfoApi,
  sendToPanelDeliverApi,
} from "../../../../Api/PanelAdminServices";
import Button from "../../../Button/Button";
import Style from "./DeliveryInfo.module.scss";
import { errorToast } from "../../../../Utils/Toast/Toast";
import { vehicleListModel } from "../../../../Utils/Helper/Helper";
import moment from "moment-jalaali";
const DeliveryInfo = ({ handleOk, Info }) => {
  const [disable, setDisable] = useState(false);
  const [deliverInfoState, setDeliverInfoState] = useState([]);
  const goToPanel = () => {
    setDisable(true);
    const info = {
      user_id: Info.id,
      user_type: "deliver",
    };
    sendToPanelDeliverApi(info, (res) => {
      setDisable(false);
      window.open(
        `https://delivery.barest.ir/login_as/index.php?token=${res.token}`
      );
    });
  };
  useEffect(() => {
    getDeliveryInfoApi(Info.id, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setDeliverInfoState(res.info);
        } else {
          errorToast(res.message);
        }
      } else {
        console.log(res);
      }
    });
  }, []);

  return (
    <div className={Style.componentHolder}>
      <ul className={Style.infoHolder}>
        <li>
          <p>نام:</p>
          <span> {deliverInfoState?.first_name}</span>
        </li>
        <li>
          <p>نام خانوادگی:</p>
          <span> {deliverInfoState?.last_name}</span>
        </li>
        <li>
          <p> کدملی:</p>
          <span> {deliverInfoState?.national_code}</span>
        </li>
        <li>
          <p> تاریخ ثبت نام:</p>
          <span style={{direction:'ltr'}}>
             
            {moment
              .unix(parseInt(deliverInfoState.inserted_in))
              .format("jYYYY/jM/jD--HH:mm")}
          </span>
        </li>
        <li>
          <p>شماره همراه:</p>
          <a href={`tel:${deliverInfoState?.phone}`}>
             {deliverInfoState?.phone}
          </a>
        </li>
        <li>
          <p>نوع وسیله نقلیه:</p> 
          {vehicleListModel[deliverInfoState?.vehicle_type]}
        </li>
        {deliverInfoState?.vehicle_model && (
          <li>
            <p>مدل وسیله نقلیه:</p>
            <span> {deliverInfoState?.vehicle_model}</span>
          </li>
        )}
        {deliverInfoState?.vehicle_plate && (
          <li>
            <p>پلاک وسیله نقلیه:</p>
            <span> {deliverInfoState?.vehicle_plate}</span>
          </li>
        )}
        {deliverInfoState?.vehicle_color && (
          <li>
            <p>رنگ وسیله نقلیه:</p>
            <span> {deliverInfoState?.vehicle_color}</span>
          </li>
        )}
      </ul>
      <div className={Style.btnHolder}>
        <Button
          Value={"وارد شدن به پنل پیک"}
          ClickHandler={goToPanel}
          ClassBtn={"okBtn"}
          disabledprops={disable}
        />
        <Button Value={"تایید"} ClickHandler={handleOk} ClassBtn={"okBtn"} />
      </div>
    </div>
  );
};

export default DeliveryInfo;
